import ReactDOM from 'react-dom'
import React from 'react'
import { usePluginContext } from '../../contexts/PluginContext'
import { toSnakeCase } from '../../helpers/stringHelper'

type ModalPortalProps = {
    children: React.ReactNode
}

const ModalPortal = ({ children }: ModalPortalProps) => {
    const { plugin_id } = usePluginContext()
    const pluginRootId = `${toSnakeCase(plugin_id)}_root`

    const modalRoot = document.getElementById(pluginRootId) ?? document.body

    return ReactDOM.createPortal(children, modalRoot)
}

export default ModalPortal
